import { useState } from 'react';
import { toast } from 'sonner';

import { useInvoiceRunFileUrlLazyQuery } from './InvoiceRunFileUrl.generated';

type DownloadableFile = { key: string; name: string };

/**
 * Result files are served through short-lived links generated fresh on every
 * click (invoiceRunFileUrl), so downloads never go stale.
 */
export function useResultFileDownload() {
  const [fetchUrl] = useInvoiceRunFileUrlLazyQuery({
    // Links are short-lived and generated fresh on click — never cache them.
    fetchPolicy: 'network-only',
  });
  const [busyKey, setBusyKey] = useState<string | null>(null);

  const download = async (file: DownloadableFile) => {
    setBusyKey(file.key);
    try {
      const { data, error } = await fetchUrl({
        variables: { key: file.key },
      });
      if (error || !data?.invoiceRunFileUrl) {
        throw error ?? new Error('No download link returned');
      }
      window.open(data.invoiceRunFileUrl, '_blank', 'noopener');
    } catch (e) {
      toast.error(
        e instanceof Error ? e.message : `Downloading ${file.name} failed`,
      );
    } finally {
      setBusyKey(null);
    }
  };

  return { download, busyKey };
}
